// Single source of truth for class types, keyed by the value stored on events
// and time slots.
//
// "other" is the stored key for CF Kids classes, so existing events keep
// working without a data migration. Barbell is retired: it stays here so old
// events still render with their color and name, but `legacy` keeps it out of
// the legend and the Add Class pickers.
export const CLASS_TYPES = {
  crossfit: { name: "CrossFit", color: "bg-custom-red", hex: "#e74c3c" },
  onRamp: { name: "On Ramp", color: "bg-custom-blue", hex: "#3498db" },
  openGym: { name: "Open Gym", color: "bg-custom-green", hex: "#2ecc71" },
  hero: { name: "Hero", color: "bg-custom-yellow", hex: "#f1c40f" },
  other: { name: "CF Kids", color: "bg-custom-orange", hex: "#e67e22" },
  barbell: { name: "Barbell", color: "bg-custom-purple", hex: "#9b59b6", legacy: true },
};

// Types that can still be picked or shown in the legend
export const ACTIVE_CLASS_TYPES = Object.fromEntries(
  Object.entries(CLASS_TYPES).filter(([, value]) => !value.legacy)
);

// Spacing-free lowercase spelling -> key, so "onRamp", "on ramp" (coverage
// endpoint) and "Open Gym" (older rows) all resolve to the same type.
const KEY_BY_COMPACT = Object.fromEntries(
  Object.keys(CLASS_TYPES).map((key) => [key.toLowerCase(), key])
);
const toKey = (type) =>
  KEY_BY_COMPACT[String(type || "").replace(/\s+/g, "").toLowerCase()];

// Display name for a stored type. Unknown types fall back to the raw value so
// nothing silently disappears.
export const getClassTypeName = (type) =>
  CLASS_TYPES[toKey(type)]?.name || type || "";

// Color info for any spelling of a type, or undefined
export const getClassType = (type) => CLASS_TYPES[toKey(type)];
